import React from "react";
import { NavLink } from "react-router-dom";

const SettingsSubnav = ({ role, handleSettingCurrentPage, manageddepartmentsAIM }) => {
    if (role === 'admin') {
        return (
            <ul>
                <li><NavLink to="settings/devices" onClick={() => handleSettingCurrentPage('settings')}>Devices</NavLink></li>
                {manageddepartmentsAIM?.length > 0 && (<li><NavLink to="settings/approvals" onClick={() => handleSettingCurrentPage('settings')}>Approvals</NavLink></li>)}
                <li><NavLink to="settings/leave" onClick={() => handleSettingCurrentPage('settings')}>Leaves</NavLink></li>
                <li><NavLink to="settings/events" onClick={() => handleSettingCurrentPage('settings')}>Events</NavLink></li>
                <li><NavLink to="settings/ndot" onClick={() => handleSettingCurrentPage('settings')}>NDOT</NavLink></li>
            </ul>
        );
    }
    
    if (role === 'manager' || role === 'supervisor') {
        return (
            <ul>
                <li><NavLink to="settings/devices" onClick={() => handleSettingCurrentPage('settings')}>Devices</NavLink></li>
                {manageddepartmentsAIM?.length > 0 && (<li><NavLink to="settings/approvals" onClick={() => handleSettingCurrentPage('settings')}>Approvals</NavLink></li>)}
            </ul>
        );
    }
    
    return null;
}

export default SettingsSubnav;